import md5 from 'md5'
import { getParams } from '@/utils/param-factory'
import { randomString, sortASCIIandStringfy } from '@/utils/mUtil'

/**
 * 获取公用的参数
 */
export function getCommonParam(type, isAll = false) {
  const commonParams = getParams(
    Object.assign(
      {
        nonce: randomString(),
        timestamp: parseInt(Date.now() / 1000),
        appid: 'credits_vd8S2VNu',
      },
      isAll ? { types: type } : { type }
    )
  )

  let secret_key = 'pXEx48lXhe7Pg3xo'.toLocaleLowerCase()
  let sortedParams =
    sortASCIIandStringfy(commonParams).toLowerCase() +
    'secret_key=' +
    secret_key
  commonParams.sign = md5(sortedParams)
  return commonParams
}

export function test() {}
